import { newsIcons } from "../assets/map/icon";
import GeoJSON from "../assets/map/countries.json";

export const updateFitBounds = (markerLocation) => {
    const map = window.intelliegenceMap;
    const bounds = new window.google.maps.LatLngBounds();
    const markers = markerLocation;
    markers
        .filter((marker) => marker.marker_priority === 1)
        .map((place) => {
            bounds.extend({ lat: place.lat, lng: place.lng });
            return place.item_id;
        });
    map.current.fitBounds(bounds);

    return markers;
};

export const getIconName = (category) => {
  let cat = category;
  if (Array.isArray(cat)) cat = cat[0];

  const icon = newsIcons.filter((icon) => icon?.category === cat?.toLowerCase());

  return icon.length ? icon[0].icon : "image";
};

export const getCoordinates = (country) => {
    try {
        let indx;
        let maxLength = 0;
        const geoJsonFilter = GeoJSON.features.filter(
            (geo) => geo.properties.ADMIN === country
        )[0].geometry.coordinates;

        geoJsonFilter.forEach((d, i) => {
            if (d[0].length > maxLength) {
                maxLength = d[0].length;
                indx = i;
            }
        });

        const coordinates = geoJsonFilter[indx][0].map((loc) => {
            return {
                lat: loc[1],
                lng: loc[0],
            };
        });

        return coordinates;
    } catch (e) {
		return [];
    }
};
